import { Base64 } from 'js-base64';
export const storageData = {
  /* expiresTime: 本地存储7天有效 */
  storage: {
    login_key: Base64.encode("LOGIN_DATA"),
    expiresTime: 6048e5,
    token_key: Base64.encode("USER_TOKEN"),
    user_type: Base64.encode("USER_TYPE"),
    info_key: Base64.encode("USER_INFO")
  },
  
  /* 登录信息 帐号密码 存储 */
  setLoginData(username, password) {
    const ms = new Date().getTime();
    username = Base64.encode(username);
    password = Base64.encode(password);
    let storageVal = {
      TTFZX1VTRVJfTkFNRQ: username,
      TTJZX1BBU1NfV09SRA: password,
      TTJFPOQWEIUAJSKLBF: ms
    };
    localStorage.setItem(this.storage.login_key, JSON.stringify(storageVal));
  },
  
  getLoginData() {
    let storageVal = localStorage.getItem(this.storage.login_key);
    if (storageVal) {
      storageVal = JSON.parse(storageVal);
      if (new Date().getTime() - storageVal.TTJFPOQWEIUAJSKLBF > this.storage.expiresTime) {
        // console.log("expires");
        this.clearLoginData(); // 清除本地存储的登录信息
      } else {
        const username = Base64.decode(storageVal.TTFZX1VTRVJfTkFNRQ);
        const password = Base64.decode(storageVal.TTJZX1BBU1NfV09SRA);
        return { u: username, p: password, flag: true };
      }
    }
    return { u: "", p: "", flag: false };
  },
  clearLoginData() {
    localStorage.removeItem(this.storage.login_key);
  },

  /* 登录成功 token 存储 */
  setToken(token) {
    this.clearToken();
    const xToken = Base64.encode(token);
    localStorage.setItem(this.storage.token_key, xToken);
  },
  getToken() {
    const xToken = localStorage.getItem(this.storage.token_key);
    if (xToken) {
      return Base64.decode(xToken);
    }
    return false;
  },
  clearToken() {
    localStorage.removeItem(this.storage.token_key);
  },

  /* 登录成功 userType 存储 */
  setUserType(userType) {
    this.clearUserType();
    const xUserType = Base64.encode(userType);
    localStorage.setItem(this.storage.user_type, xUserType);
  },
  getUserType() {
    const xUserType = localStorage.getItem(this.storage.user_type);
    if (xUserType) {
      return Base64.decode(xUserType);
    }
    return false;
  },
  clearUserType() {
    localStorage.removeItem(this.storage.user_type);
  },

  /* 登录成功 userInfo 存储 */
  setUserInfo(info) {
    info = JSON.stringify(info);
    info = Base64.encode(info);
    localStorage.setItem(this.storage.info_key, info);
  },
  getUserInfo() {
    let info = localStorage.getItem(this.storage.info_key);
    if (info) {
      info = Base64.decode(info);
      return JSON.parse(info);
    }
    return false;
  },
  clearUserInfo() {
    localStorage.removeItem(this.storage.info_key);
  },
  setVideoPlayTime(i) {
    localStorage.setItem("video_play_time_num", i);
  },
  getVideoPlayTime() {
    let num = localStorage.getItem("video_play_time_num");
    if(num) return num;
    else return 0;
  },
};
